// Bileli · shared/lib — zustand (vanilla) + a Teact adapter hook. why: the user wants the Bileli side on
// standard libraries; zustand's CORE is framework-free (React binding unused — it can't run in Teact).
// Stores are created with `createStore` from 'zustand/vanilla' and live OUTSIDE the component tree (the
// media engine mutates them from plain TS); components subscribe through `useStoreState`.

import type { StoreApi } from 'zustand/vanilla';
import { useEffect, useRef, useState } from '../../../lib/teact/teact';

export { createStore } from 'zustand/vanilla';
export type { StoreApi } from 'zustand/vanilla';

/** Subscribe a Teact component to a slice of a zustand store (re-renders only when the slice changes). */
export function useStoreState<T, S>(store: StoreApi<T>, selector: (s: T) => S): S {
  const tickRef = useRef(0);
  // eslint-disable-next-line @eslint-react/use-state -- force-update tick: only the setter is used
  const [, setTick] = useState(0);
  const selRef = useRef(selector);
  selRef.current = selector;
  const value = selector(store.getState());
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => store.subscribe((state) => {
    const next = selRef.current(state);
    if (next !== valueRef.current) {
      tickRef.current += 1;
      setTick(tickRef.current);
    }
  }), [store]);

  return value;
}
